import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TimeTrackerViews } from '@macs-frontend/features/time-tracking/time/models/time-tracker-views';
import { Tab } from '@macs-frontend/features/time-tracking/time/time.store';

@Component({
  selector: 'md-timetracking-calendar-actions',
  templateUrl: 'calendar-actions.component.html',
  styleUrls: ['./calendar-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimetrackingCalendarActionsComponent implements OnInit {
  @Input() viewTabs: Tab[] = [];
  @Input() activeView?: TimeTrackerViews;
  @Input() todaySelected = false;
  @Input() thisWeekSelected = false;
  @Input() hideAddEventButton = false;

  @Output() changeView = new EventEmitter<TimeTrackerViews>();
  @Output() goPrevious = new EventEmitter<void>();
  @Output() goTodayOrThisWeek = new EventEmitter<void>();
  @Output() goNext = new EventEmitter<void>();
  @Output() closeHandler = new EventEmitter<void>();
  @Output() addNewEntry = new EventEmitter<void>();

  readonly TimeTrackerViews = TimeTrackerViews;

  constructor() {}

  ngOnInit() {}
}
